'use client';
import { isArray } from '@s7/utils';
import { EVENT_BUS } from './bus.js';
import { hasIID, getIID } from '../../utils/iid.js';

const isInvalidationNotifierCompositeArray = (candidate)=>{
    return isArray(candidate) && isArray(candidate.at(0));
};
const notifyByKey = (quid)=>EVENT_BUS.emit(quid);
const notifyByCompositeKey = (selector)=>{
    const [hook, dataIdent] = selector;
    EVENT_BUS.emit(`${getIID(hook)}${dataIdent}`);
};
const notifyQueries = (subscribers, data)=>{
    for (const subscriber of subscribers){
        if (hasIID(subscriber)) {
            const quid = getIID(subscriber);
            notifyByKey(quid);
            continue;
        }
        const idents = subscriber(data);
        if (isInvalidationNotifierCompositeArray(idents)) {
            idents.forEach(notifyByCompositeKey);
        } else {
            notifyByCompositeKey(idents);
        }
    }
};
const useInvalidationNotifier = ()=>notifyQueries;

export { useInvalidationNotifier };
//# sourceMappingURL=useInvalidationNotifier.js.map
